export default {
  namespaced: true,
  state: {
    participants: {}
  },
  getters: {
    all: state => {
      return state.participants
    },
    getByUserId: state => id => {
      if (!Object.prototype.hasOwnProperty.call(state.participants, id)) return []

      return state.participants[id]
    },
    getByHallAndRoomSlug: state => (hallSlug, roomSlug) => {
      if (!state.participants) return []

      return _.filter(state.participants, {hall: hallSlug, room: roomSlug, isActive: true})
    },
    countByHallSlug: state => hallSlug => {
      if (!state.participants) return 0

      return _.filter(state.participants, {hall: hallSlug, isActive: true}).length
    },
    countByHallAndRoomSlug: state => (hallSlug, roomSlug) => {
      if (!state.participants) return 0

      return _.filter(state.participants, function(participant) {
        return participant.type !== 1 && participant.hall === hallSlug && participant.room === roomSlug && participant.isActive
      }).length
    },
    getExceptSelf: state => authId => {
      const results = {}
      _(state.participants)
        .filter(participant => {
          return participant.id !== authId
        })
        .forEach(participant => {
          results[participant.id] = participant
        })

      return results
    }
  },
  mutations: {
    init(state, participants) {
      const results = {}
      _(participants)
        .orderBy(["isActive", "updatedAt"], ["desc", "desc"])
        .forEach(participant => {
          results[participant.id] = participant
        })

      state.participants = results
    },
    set(state, participant) {
      const results = {}
      state.participants[participant.id] = participant
      _(state.participants)
        .orderBy(["isActive", "updatedAt"], ["desc", "desc"])
        .forEach(participant => {
          results[participant.id] = participant
        })

      state.participants = results
    }
  },
  actions: {
    convertAll(state, socketIf) {
      const all = {}
      socketIf.body.forEach(participant => {
        all[participant.id] = participant
      })

      state.commit("init", all)
    },
    updateParticipant(state, socketIf) {
      state.commit("set", socketIf.body)
    }
  }
}
